<template>
    <Frame class="bind" :name="title">
        <BindResult v-if="type==1"/>
        <BindForm v-else />
        <!-- <Step class="steps" :current="current" />
        <component :is="moduleId"></component> -->
    </Frame>
</template>

<script>
import Frame from '@components/commonFramework/index'
import BindForm from './bindForm'
import BindResult from './bindResult'

export default {
    data() {
        return {
            moduleId: '',
            title: '绑定手机',
        }
    },
    computed: {
        type() {
            return this.$route.query.type || 0
        }
    },
    components: {
        Frame,
        BindForm,
        BindResult
    } 
}
</script>